.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1.6rem;
  height: 100%;
}

.wrapper-box {
  display: flex;
  flex-direction: column;
  max-width: 32rem;
  align-items: center;
  gap: 1.6rem;

  &[data-full-width='true'] {
    max-width: unset;
  }
}

.description {
  line-height: 2rem;
  text-align: center;
}

.action-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
}

.logo-background {
  width: 100%;
  height: 100%;
  max-width: 67.6rem;
  max-height: 60.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* The original emitted `background-image` only when a URL was given, so the
     property is set inline and no declaration appears here. */
  background-repeat: no-repeat;
  background-position: center;
}
